import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSelector = () => {
    const { language, changeLanguage, supportedLanguages } = useLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Dışarı tıklandığında dropdown'ı kapat
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleLanguageChange = (langCode) => {
        changeLanguage(langCode);
        setIsOpen(false);
    };

    const currentLanguage = supportedLanguages[language];

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 rounded-lg bg-transparent font-medium text-gray-500 dark:text-white dark:hover:bg-none hover:text-purple-700 dark:hover:text-purple-600 hover:bg-gray-100 dark:hover:bg-white-700 transition-all flex items-center space-x-1"
                title={currentLanguage?.name || 'Language'}
            >
                <Globe className="h-4 w-4 sm:h-5 sm:w-5" />
                <span className="hidden sm:inline text-xs font-medium uppercase">
                    {language}
                </span>
            </button>

            {isOpen && (
                <>
                    <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50">
                        <div className="py-1">
                            {Object.values(supportedLanguages).map((lang) => (
                                <button
                                    key={lang.code}
                                    onClick={() => handleLanguageChange(lang.code)}
                                    className={`w-full text-left px-4 py-2 text-sm flex items-center space-x-2 transition-colors ${language === lang.code
                                        ? 'bg-indigo-100 dark:bg-indigo-900 text-indigo-700 dark:text-indigo-300'
                                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
                                        }`}
                                >
                                    <span className="font-medium">{lang.name}</span>
                                    {language === lang.code && (
                                        <span className="ml-auto text-xs">✓</span>
                                    )}
                                </button>
                            ))}
                        </div>
                    </div>
                    {/* Overlay */}
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setIsOpen(false)}
                    />
                </>
            )}
        </div>
    );
};

export default LanguageSelector;

